import i18n from './i18n'

export * from './components'
export * from './helpers'
export * from './hooks'
export * from './model'
export * from './strategies'

export default i18n
